import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/**
 * SidebarNav - Container for sidebar navigation items
 */
export const SidebarNav = forwardRef<HTMLElement, HTMLAttributes<HTMLElement>>(
  ({ className, ...props }, ref) => (
    <nav
      ref={ref}
      className={cn('flex flex-col h-full gap-1 px-3', className)}
      {...props}
    />
  )
);
SidebarNav.displayName = 'SidebarNav';
